import { createHashRouter, Navigate, Outlet } from 'react-router-dom';
import { useApp } from '@/context/AppContext';
import { LandingPage, LoginPage, SignupPage, CourseSelectPage, DashboardPage, ExperimentPage, AdminDashboard, AuthCallbackPage, StudentProgressPage } from '@/pages';
import { AdminLayout, AdminSettings } from '@/components/admin';

// Auth Guard - Redirects to login if not authenticated
function AuthGuard() {
  const { state } = useApp();

  if (!state.isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}

// Course Guard - Ensures a course is selected (optional, for future use)
function CourseGuard() {
  return <Outlet />;
}

// Redirect from root based on auth state
function RootRedirect() {
  const { state } = useApp();

  if (state.isAuthenticated) {
    return <Navigate to="/courses" replace />;
  }

  return <LandingPage />;
}

export const router = createHashRouter([
  {
    path: '/',
    element: <RootRedirect />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/signup',
    element: <SignupPage />,
  },
  {
    path: '/auth/callback',
    element: <AuthCallbackPage />,
  },
  {
    element: <AuthGuard />,
    children: [
      {
        path: '/courses',
        element: <CourseSelectPage />,
      },
      {
        path: '/admin',
        element: <AdminLayout />,
        children: [
          {
            index: true,
            element: <AdminDashboard />,
          },
          {
            path: 'users',
            element: <AdminDashboard />,
          },
          {
            path: 'courses',
            element: <AdminDashboard />,
          },
          {
            path: 'settings',
            element: <AdminSettings />,
          },
          {
            path: 'settings/ai',
            element: <AdminSettings />,
          },
          {
            path: 'settings/auth',
            element: <AdminSettings />,
          },
        ],
      },
      {
        element: <CourseGuard />,
        children: [
          {
            path: '/course/:courseId',
            element: <DashboardPage />,
          },
          {
            path: '/course/:courseId/experiment/:expId',
            element: <ExperimentPage />,
          },
          {
            path: '/course/:courseId/progress',
            element: <StudentProgressPage />,
          },
        ],
      },
    ],
  },
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
]);

export default router;
